import { render, staticRenderFns } from "./UserGroupItem.vue?vue&type=template&id=fd259c70&scoped=true&"
import script from "./UserGroupItem.vue?vue&type=script&lang=js&"
export * from "./UserGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupItem.vue?vue&type=style&index=0&id=fd259c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd259c70",
  null
  
)

component.options.__file = "UserGroupItem.vue"
export default component.exports